<template>
  <div class="section">
    <div class="container questionnaire-spacing">
      <div class="columns">
        <div class="column questionnaire-section-header">
          <div class="title is-2 has-text-weight-bold">Variable B</div>
          <p>
            <b>Variable B</b> is (i) reported precedent, meaning (a) judicial decisions, and (b) RANJA, in each case with analysis by AWG's legal advisory panel, as or to be posted on the CTC academic project website, and (ii) experience, advised by experts, in applying and enforcing CTC.
          </p>
        </div>
      </div>
      <br />
      <div v-if="$store.getters['isAdmin']">
        <div class="title is-3">Admin Notes</div>
        <editor apiKey="0qgi7f55b2ue7vvn7vvi7w9zim05110j4aznns846hbq588x"
                v-model="adminComment"
                :disabled="$store.getters.currentQuestionnaire.Status == 'Closed'"
                :init="{
                    menubar: false,
                    plugins: [
                    'autoresize',
                    'wordcount'
                    ],
                    toolbar:
                    'formatselect | bold italic underline | \
                    bullist numlist outdent indent | removeformat | spellchecker',
                    browser_spellcheck: true
       }"></editor>
        <hr />
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  import Editor from '@tinymce/tinymce-vue'
  export default {
    data() {
      return {
        adminComment: ''
      }
    },
    components: {
      'editor': Editor
    },
    methods: {
      async saveAdminComment(sectionId) {
        await this.$http.post("api/questionnaire/adminComment/save", { questionnaireId: this.$store.getters["currentQuestionnaire"].Id, sectionId: sectionId, comment: this.adminComment });
      },
      async getAdminComment(sectionId) {
        await this.$http.post("api/questionnaire/adminComment", { questionnaireId: this.$store.getters["currentQuestionnaire"].Id, sectionId: sectionId })
          .then(resp => {
            if (resp.data.Comment != null) {
              this.adminComment = resp.data.Comment;
            }
            else {
              this.adminComment = "";
            }
          }).catch(err => {
            this.$buefy.notification.open("Could not load Admin Comment.");
          })
      }
    },
    created() {

    }
  }
</script>
